module.exports = __webpack_public_path__ + "static/media/region.61d06055.webp";